import React, { Component } from 'react'
import { Redirect } from 'react-router-dom'
import axios from 'axios'

import Title from './../elements/TitlePages'

class ProductEdit extends Component {
  constructor (props) {
    super(props)
    this.state = {
      product: '',
      redirect: false
    }
    this.handleEditProduct = this.handleEditProduct.bind(this)
  }

  componentDidMount() {
    axios.get(window.baseURL + '/products/' + this.props.match.params.prodID).then(response => {
      this.setState({product: response.data})
    }).catch(e => { 
      console.log(e)
    })
  }

  handleEditProduct (e) {
    e.preventDefault()
    //console.log(this.state.product[0].id, this.refs.prodName.value)
    axios.post(window.baseURL + '/products/editProd/', {
      prodId: this.state.product[0].id,
      prodName: this.refs.prodName.value,
     }, {headers: { 'Content-Type': 'application/json' }}).then(response => {
      if (response.data === 'ok') {
        this.setState({ redirect: true })
      } 
    }).catch(e => {
      console.log(e)
    })
  }

  renderFormEdit () {
    return (
      <div>
        <Title title={'Edit Product'} />
        <div className='row'>
          <div className='col-md-3'>
            <form className='form-signin' onSubmit={this.handleEditProduct} >
              <input className='form-control' name="prodName" type="text" ref="prodName" placeholder="Product Name" defaultValue={this.state.product[0].prodName} required />
               <br />
              <button className='btn btn-success' type='submit' width='80%'>Salvar</button>
            </form>
          </div>
        </div>
      </div>
    )
  }

  render () {
    if (this.state.redirect) {
     return <Redirect to='/main' />
    }
    return this.state.product === '' ? <div /> : this.renderFormEdit() 
  }
}

export default ProductEdit
